var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 316,
    viewBox: "0 0 1728 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_2989)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 316,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.589844,
    width: 1728,
    height: 315,
    fill: "url(#paint0_linear_214_2989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.4 0.448251L976.62 211.138L1198.88 153.378L1301.25 276.231L1115.19 315.575L856.694 315.575L806.194 315.575L793.653 300.032L882.258 89.8748L920.309 0.448243L959.332 0.448244L1076.4 0.448251Z",
    fill: "url(#paint1_linear_214_2989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.410156V315.59H954.127C975.838 287.411 1017.5 101.233 862.587 1.60258L0 -0.410156Z",
    fill: "url(#paint2_linear_214_2989)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_2989",
    x1: 0,
    y1: 158.09,
    x2: 1728,
    y2: 158.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5B0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC9FB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_214_2989",
    x1: 1126.19,
    y1: -98.9246,
    x2: 976.694,
    y2: 457.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AE30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_214_2989",
    x1: 603.072,
    y1: 76.3469,
    x2: -4.07064,
    y2: 220.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD98C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9482A7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_2989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 316,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearner);
export default __webpack_public_path__ + "static/media/learner.ff33d4335f3c4c778d70d815d21e496b.svg";
export { ForwardRef as ReactComponent };